import { useEffect } from "preact/hooks";
import { useVideoRecorder } from "@webcore/ui/hooks/useVideoRecorder";
import { Fade } from "@webcore/ui/components/Transitions/Fade";
import emitter from "@webcore/core/events/eventemitter";
import { RecordButton } from "@components/Common";
import VideoPreview from "@components/Media/VideoPreview";
import { AppState, RecordingState, useAppContext } from "@/context/AppContext";


export const VideoRecorderUI = () => {
  const {appState, recordingState, setRecordingState} = useAppContext();
  // Initialize video recorder
  const recorder = useVideoRecorder({
    maxDuration: 15000,
    progressUpdateInterval: 100,
    eventPrefix: 'record',
  });

  useEffect(() => {
    // Set up recording event handlers
    const handleRecordingStart = () => {
      setRecordingState(RecordingState.RECORDING);
    };

    const handleRecordingStop = () => {
      //setRecordingState(RecordingState.PREVIEW);
    };

    const handleRecordingCompleted = () => {
      setRecordingState(RecordingState.PREVIEW);
    };

    const handleRecordingError = (error: string) => {
      console.error('handleRecordingError:', error);
      setRecordingState(RecordingState.NONE);
    };

    emitter.on("record-started", handleRecordingStart);
    emitter.on("record-stopped", handleRecordingStop);
    emitter.on("record-completed", handleRecordingCompleted);
    emitter.on("record-error", handleRecordingError);
    
    return () => {
      emitter.off("record-started", handleRecordingStart);
      emitter.off("record-stopped", handleRecordingStop);
      emitter.off("record-completed", handleRecordingCompleted);
      emitter.off("record-error", handleRecordingError);
    };
  }, []);

  const handlePreviewClose = () => {
    recorder.clear();
    setRecordingState(RecordingState.NONE);
  };

  const handlePreviewShare = () => {
    if (recorder.videoUrl) {
      const shareData: ShareData = {
        url: recorder.videoUrl,
        title: 'EJW Boilerplate',
        text: 'Check out this AR video!',
      };
      emitter.emit("share", shareData);
    }
    recorder.clear();
    setRecordingState(RecordingState.NONE);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 top-0">
      <Fade visible={appState === AppState.EXPERIENCE && (recordingState === RecordingState.RECORDING || recordingState === RecordingState.NONE)}>
        <div className="absolute bottom-24 left-1/2 transform -translate-x-1/2 z-50">
          <RecordButton recorder={recorder} />
        </div>
      </Fade>

      <Fade visible={appState === AppState.EXPERIENCE && recordingState === RecordingState.PREVIEW}>
        <VideoPreview videoUrl={recorder.videoUrl} onClose={handlePreviewClose} onShare={handlePreviewShare} />
      </Fade>
    </div>
  );
};

